<template>
  <div id="create-batch-report-modal" tabindex="-1" aria-hidden="true" data-modal-backdrop="static"
    class="fixed top-0 left-0 right-0 z-50 items-center justify-center hidden w-full overflow-x-hidden overflow-y-auto md:inset-0 h-modal md:h-full">
    <div class="relative w-full   max-w-2xl  ">
      <!-- Modal content -->
      <div class=" relative pt-4 pb-2 bg-gray-200 rounded-lg shadow   ">
        <!-- Modal header -->

        <div class="px-4 flex items-center justify-between pb-2 mb-2 border-b border-gray-200 rounded-t sm:mb-2 ">

          <h3 v-if="input?.mode == 'display'" class="font-semibold text-gray-900 text-lg   ">
            {{ labels['TITLE_EDIT_BATCH'][lg] }} {{ input?.source?.batch_number }}
          </h3>
          <h3 v-if="input?.mode == 'create'" class="font-semibold text-gray-900 text-lg   ">
            {{ labels['TITLE_CREATE_BATCH'][lg] }}
          </h3>
          <button type="button"
            class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 inline-flex "
            @click=" onClose()">
            <svg aria-hidden="true" class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd"
                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                clip-rule="evenodd" />
            </svg>
            <span class="sr-only">Close modal</span>
          </button>
        </div>
        <div class="relative bg-gray-50 rid gap-4 mb-4 sm:grid-cols-1 sm:gap-6 sm:mb-5 p-4">
          <div class="w-full  flex flex-col ">







            <div class="mt-2 w-full    flex">


              <div class="   text-left justify-start mr-2 flex flex-row items-center py-2">
                <label for="game_specie_id" class="w-36  block   text-sm font-semibold text-gray-900 ">
                  {{ labels['TITLE_ENTITY'][lg] }} </label>
                <select id="hunting-item-nemrod_comment_id" v-model="entity_id" :disabled="(input?.mode == 'display')"
                  class="w-72   border border-gray-300 text-gray-900   text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block   p-2   "
                  :class="{ 'bg-gray-50': input?.mode == 'create', 'bg-gray-200': input?.mode == 'display' }"
                  @change="onEntityChanged">
                  <option v-for="entity in filteredEntities" :key="entity._id" :value="entity._id">{{ entity.name }}
                  </option>

                </select>
              </div>


            </div>
            <hr />


            <div class="mt-2 w-full    flex">


              <div class="   text-left justify-start mr-2 flex flex-row items-center py-2">
                <label for="hunting-item-number"
                  class="w-36 block  max-w-36  text-sm font-semibold text-gray-900  mr-2">
                  {{ labels['TITLE_DONE_AT'][lg] }} </label>
                <ContentDate :mode="input?.mode" :id="`content-date-input-${id}-delivery-report`" class="max-w-36     "
                  ref="content-date-input-delivery-report" :config="config_date" index="200" placeholder=""
                  :value="controlled_at" @update-field="onDateValueChanged" @value-changed="onDateValueChanged" />
              </div>


            </div>
            <hr />


            <div class="mt-2 w-full    flex">
              <div class="    text-left justify-start mr-2 flex flex-row items-center py-2">
                <label for="game_specie_id" class="w-36 max-w-36  block   text-sm font-semibold text-gray-900 ">
                  {{ labels['TITLE_CONTROLLED_BY'][lg] }} </label>
                <select id="hunting-item-nemrod_comment_id" v-model="controlled_by_id"
                  class="w-72  bg-gray-50 border border-gray-300 text-gray-900   text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block   p-2  ">
                  <option v-for="vet in vets" :key="vet._id" :value="vet._id"> {{ vet.name }} </option>
                </select>
              </div>


            </div>
            <div class="mt-2 w-full    flex">
              <div class="   text-left justify-start mr-2 flex flex-row items-center py-2">
                <label for="game_specie_id" class="w-36 max-w-36  block   text-sm font-semibold text-gray-900 ">
                  {{ labels['TITLE_REVIEWED_BY'][lg] }} </label>
                <select id="hunting-item-nemrod_comment_id" v-model="reviewed_by_id"
                  class="w-72  bg-gray-50 border border-gray-300 text-gray-900   text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block   p-2  ">
                  <option v-for="member in members" :key="member._id" :value="member._id"> {{ member.name }} </option>
                </select>
              </div>

            </div>

            <div class=" w-full flex flex-row   mt-6 py-2">


            </div>

          </div>
          <div class="absolute top-0 left-0 w-full h-full  bg-gray-50 flex items-center justify-center"
            :class="{ 'block': !show_form, 'hidden': show_form }">
            <div class="flex items-center">


              <div role="status">
                <svg aria-hidden="true" class="w-8 h-8 text-gray-200 animate-spin  fill-blue-600" viewBox="0 0 100 101"
                  fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="currentColor" />
                  <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentFill" />
                </svg>
                <span class="sr-only">Loading...</span>
              </div>
              <div class="font-bold text-lg ml-2">
                Chargement en cours
              </div>

            </div>
          </div>
        </div>

        <div class="flex items-center justify-between px-4  ">
          <div class="text-gray-500 italic text-xs">
            *109*
          </div>
          <div class="flex items-center justify-end">
            <button type="button"
              class="mr-3 py-2.5 px-5 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-primary-700 focus:z-10 focus:ring-4 focus:ring-gray-200      "
              @click=" onClose()">
              Annuler
            </button>
            <button type="button" :disabled="disabledValidate"
              class="inline-flex items-center text-white   font-bold rounded-lg text-sm px-5 py-2.5 text-center  "
              :class="{ 'bg-gray-400': disabledValidate, 'bg-gray-600 hover:bg-gray-700 focus:ring-4 focus:outline-none focus:ring-gray-300': !disabledValidate }"
              @click="onValidate">
              MODIFIER
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import labels from "@/assets/lg/hunting-batch.json"
import ContentDate from '@/components/content/ContentDate.vue'
import service from "@/services/FullService.vue"
import { mapGetters } from "vuex";

export default {
  name: 'BatchNumberChangeModal',
  props: {
    input: Object
  }, components: {
    ContentDate
  },
  computed: {
    ...mapGetters({ user: "StateUser" }),
    filteredEntities: function () {

      if (this.user?.entity_id == undefined) return this.entities;
      if (this.user?.entity_id == "") return this.entities;
      if (this.user.entity_id == "all") return this.entities;

      let user = this.user;

      if (this.entities == undefined) return [];
      if (this.entities?.length == 0) return [];

      let entity = this.entities.find(a => a._id === user.entity_id);

      let a = [];
      a.push(entity);

      //  this.entity_id =this.user.entity_id 
      return a;
    },
    disabledValidate: function () {
      if (this.controlled_by_id == undefined) return true;
      if (this.reviewed_by_id == undefined) return true;
      if (this.entity_id == undefined) return true;
      if (this.controlled_at == undefined) return true;

      if (this.controlled_by_id == "") return true;
      if (this.reviewed_by_id == "") return true;
      if (this.entity_id == "") return true;
      if (this.controlled_at == "") return true;

      //if (this.weight_gross == "") return true;
      return false
    },
    checkBatchNumber() {
      let str = this.value
      if (str == undefined) return false

      const regex = /^([AS])-(\d{2})-(\d{3})-(\d{2})$/;
      const match = str.match(regex);

      if (!match) {
        return false; // La chaîne ne correspond pas à la structure de base
      }

      // Extraire chaque partie
      const [_, X, YY, NNN, MM] = match;
      console.log(_)
      console.log(X)
      // Vérifier que YY est entre 22 et 26
      const year = parseInt(YY, 10);
      if (year < 22 || year > 26) {
        return false;
      }

      // Vérifier que NNN est un nombre inférieur à 365
      const nnn = parseInt(NNN, 10);
      if (nnn < 0 || nnn >= 365) {
        return false;
      }

      // Vérifier que MM ne contient que des chiffres
      if (!/^\d{2}$/.test(MM)) {
        return false;
      }

      // Tous les tests ont réussi
      return true;

    },
    isLoggedIn: function () {
      return this.$store.getters.isAuthenticated;
    },
  },
  data() {
    return ({
      lg: "FR",
      labels: labels,
      price: "",
      mode: "",
      id: null,
      entity_id: null,
      controlled_at: null,
      config_date: null,
      show_form: false,
      controlled_by_id: null,
      reviewed_by_id: null,
      entities: [],
      vets: [],
      members: [],

      value: ""
    })
  },
  watch: {
    'filteredEntities': async function () {
      if ((this.user.entity_id != null) && (this.user.entity_id != "all"))
        this.entity_id = this.user.entity_id
      else
        if (this.entities.length == 1) this.entity_id = this.entities[0]._id


    },
    'input': async function () {
      this.id = this.input?.id
      this.value = this.input?.batch_number

      this.$nextTick(() => {
        //this.$refs['input-batch-number'].focus();
      });

      if (this.members.length == 0) {
        await this.loadMembers()
      }

      if (this.vets.length == 0) {
        await this.loadVets()
      }

      if (this.entities.length == 0) {
        await this.loadEntities()
      }
      this.controlled_at = this.formatDate(this.input?.source?.controlled_at)
      this.controlled_by_id = this.input?.source?.controlled_by_id
      this.reviewed_by_id = this.input?.source?.reviewed_by_id
      if (this.input?.source?.entity_id != null) {
        this.entity_id = this.input?.source?.entity_id;

      }
      else {
        if ((this.user.entity_id != null) && (this.user.entity_id != "all")) {
          this.entity_id = this.user.entity_id

        }

        else
          if (this.entities.length == 1) {

            this.entity_id = this.entities[0]._id
          }

      }
      this.show_form = false
      this.view = this.input?.view
      this.show_form = true
    }
  },
  async mounted() {
    this.id = this.input?.id
    this.value = this.input?.batch_number

    this.$nextTick(() => {
      // this.$refs['input-batch-number'].focus();
    });
  },

  methods: {
    formatDate(d) {


      let s = d.split("T")

      let ss = s[0].split("-")
      return ss[0] + "-" + ss[1] + "-" + ss[2]
    },
    onDateValueChanged(val) {
      this.controlled_at = val
    },
    async loadEntities() {
      {
        //inbound-pricing-lists
        let datasource = "66a4a20e8d43c894c147758d"

        let filters = {}
        let collection = "data-sources/" + datasource + "/records?limit=500"
        let entities = await service.getData(collection, this.user?.token, filters)

        this.entities = entities.records;

      }

    },

    async loadMembers() {
      {
        //inbound-pricing-lists
        let datasource = "6752c9b77b9529cfdc2feb50"

        let filters = {

          entity_id: this.input?.source?.entity_id,
          limit: 500
        }
        let collection = "data-sources/" + datasource + "/records"
        let actors = await service.getData(collection, this.user?.token, filters)

        this.members = actors.records;
      }

    },
    async loadVets() {
      {
        //inbound-pricing-lists
        let datasource = "676050ebd9dcb7dc55ca6f1e"

        let filters = {
          entity_id: this.input?.source?.entity_id,
          limit: 500
        }
        let collection = "data-sources/" + datasource + "/records"
        let actors = await service.getData(collection, this.user?.token, filters)

        this.vets = actors.records;
      }

    },



    onValidate() {


      let item =
      {
        id: this.id,
        batch_number: this.input.batch_number,
        input: this.input,
        entity_id: this.entity_id,
        action: this.input.action,
        target:
        {
          controlled_at: this.controlled_at,
          controlled_by_id: this.controlled_by_id,
          reviewed_by_id: this.reviewed_by_id,
        }

      }

      this.show_form = false
      this.$emit("confirm", item)
      // this.name = ""
    },
    onClose() {
      this.show_form = false
      this.$emit("close")

    }
  },

}
</script>